import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Button, FormControl, MenuItem, Dialog, Grid, List, ListItem, TextField, Typography } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import ReactPlayer from 'react-player';
import { toast } from 'react-toastify';
import _ from 'lodash';
import OverLoading from '../global/OverLoading';
import Constants, { Status } from '../../common/constants';
import { IsEmpty } from '../../common/checks';
import { getCategories } from '../../actions/admin/category';
import { convertScrappedPromoToPost, getScrappedPromos, updateScrappedPromo } from '../../actions/admin/scrappedPromoAction';
import PostTypeModal from '../post/postTypeModal';
import ScrappedPromo from './scrappedPromo';
import DateRangePicker from '../global/form/DateRangePicker';
import apiService from '../../services.js/apiService';

const ScrappedPostList = (props) => {
  const [loading, setLoading] = useState(false);
  const [scrappedPromos, setScrappedPromos] = useState([]);
  const [showVideo, setShowVideo] = useState(false);
  const [showAddPostModal, setShowAddPostModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [scrappedPromoToConvert, setScrappedPromoToConvert] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [categorySelection, setCategorySelection] = useState([]);
  const [brand, setBrand] = useState('');
  const [type, setType] = useState('');
  const [status, setStatus] = useState('Pending');
  const [lastUpdatedBy, setlastUpdatedBy] = useState('');
  const [updatedAt, setUpdatedAt] = useState([]);
  const [orderDir, setoOrderDir] = useState('DESC');
  const [orderBy, setOrderBy] = useState('score');
  const [allPostCount, setAllPostCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 5;
  const [pageNo, setPageNo] = useState(1);
  const [catId, setCatId] = useState(null);
  const [filterGroupLabel, setFilterGroupLabel] = useState(false);
  const [filterGroupLabelOptions, setFilterGroupLabelOptions] = useState([]);
  const [staffNames, setStaffNames] = useState([]);

  const handleChange = (event, value) => {
    setPageNo(value);
  };

  async function fetchScrappedPostData(filters) {
    setLoading(true);
    // backend accepts the paging starting from index 0
    const payload = { ...filters, pageNo: pageNo - 1, orderDir, orderBy };
    await props.getScrappedPromos(payload)
      .then((result) => {
        if (result) {
          setLoading(false);
          setAllPostCount(result.totalCount);
          setScrappedPromos(result.data);

          // Check if whole number. returns true otherwise false.
          if (Number.isInteger(result.totalCount / pageSize)) {
            setTotalCount(Math.floor(result.totalCount / pageSize));
          } else {
            // we add +1 from the total count for the remainder.
            setTotalCount(Math.floor(result.totalCount / pageSize) + 1);
          }
        }
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  }

  const fetchStaffNames = async () => {
    try {
      const names = await apiService.getStaffUsernames();
      setStaffNames(names || []);
    } catch (err) {
      // Note: should be 'toast.error(err.message)', but because the underlying
      // function ThrowErrorMsg() is throwing a string instead of 'new Error(msg)'
      // so here we use toast.error(err);
      toast.error(err);
    }
  };

  async function fetchCategoriesData() {
    const set = new Set();
    let list = [];
    const categories = await props.getCategories();
    categories.forEach((category) => {
      if (!set.has(category.id)) { list.push(category); }
    });

    list = _.mapValues(_.groupBy(list, 'group'), (v) => _.sortBy(v, 'name'));
    const temp = [];
    const sortList = Object.keys(list).sort();

    for (let x = 0; x < sortList.length; x += 1) {
      temp.push(list[sortList[x]]);
    }
    const newList = [].concat(...temp);
    setCategorySelection(newList);
  }

  async function handleChangeCategory(category) {
    setPageNo(1);
    let catValue = null;
    if (!IsEmpty(category)) {
      if (_.isObject(category)) {
        setSelectedCategory(category.id);
        setCatId(category.id);
        catValue = _.parseInt(category.id);
      } else {
        setSelectedCategory(category);
        setCatId(category);
        catValue = category;
      }
      fetchScrappedPostData({ brand, type, status, lastUpdatedBy, updatedAt, catId: catValue, pageSize, pageNo });
    } else {
      setCatId(null);
    }
  }

  useEffect(() => {
    const clear = document.getElementsByClassName(
      'MuiAutocomplete-clearIndicator',
    )[0];
    clear.click();

    if (filterGroupLabel === false) {
      setFilterGroupLabelOptions([]);
    } else if (!IsEmpty(categorySelection) && filterGroupLabel) {
      const groupCategories = _.uniq(categorySelection.map((cs) => cs.group));
      setFilterGroupLabelOptions(groupCategories);
    }

    setSelectedCategory();
    setCatId(null);
  }, [filterGroupLabel]);

  async function handleChangePageTypeFilter(value) {
    setType(value);
  }

  // Track if this is the initial mount
  const isInitialMount = useRef(true);

  useEffect(() => {
    // Only run once on mount
    fetchStaffNames();
    fetchCategoriesData();
  }, []);

  useEffect(() => {
    // Reset to page 1 when filters change (but don't fetch yet)
    if (!isInitialMount.current) {
      setPageNo(1);
    }
  }, [brand, type, status, lastUpdatedBy, updatedAt, catId, filterGroupLabel, orderDir, orderBy]);

  useEffect(() => {
    // Fetch data whenever pageNo or filters change
    fetchScrappedPostData({
      brand,
      type,
      status,
      lastUpdatedBy,
      updatedAt,
      catId,
      pageSize,
      pageNo,
    });

    // Mark that initial mount is complete
    if (isInitialMount.current) {
      isInitialMount.current = false;
    }
  }, [pageNo, brand, type, status, lastUpdatedBy, updatedAt, catId, filterGroupLabel, orderDir, orderBy]);

  const handleOnChange = (e) => {
    switch (e.target.name) {
      case 'status':
        setStatus(e.target.value);
        break;
      case 'lastUpdatedBy':
        setlastUpdatedBy(e.target.value);
        break;
      case 'orderBy':
        setOrderBy(e.target.value);
        break;
      case 'orderDir':
        setoOrderDir(e.target.value);
        break;
      default:
    }
  };

  const setDatesFilter = (dates) => {
    if (!IsEmpty(dates) && dates.length > 1) {
      const arrDate1 = new Date(dates[0]);
      const arrDate2 = new Date(dates[1]);
      const dateFrom = `${arrDate1.getFullYear()}-${(arrDate1.getMonth() + 1).toString().padStart(2, '0')}-${arrDate1.getDate().toString().padStart(2, '0')}`;
      const dateTo = `${arrDate2.getFullYear()}-${(arrDate2.getMonth() + 1).toString().padStart(2, '0')}-${arrDate2.getDate().toString().padStart(2, '0')}`;

      setUpdatedAt([dateFrom, dateTo]);
    } else {
      setUpdatedAt([]);
    }
  };

  const onSearchClicked = (value) => {
    setBrand(value);
    setPageNo(1);
    fetchScrappedPostData({ brand: value, type, status, lastUpdatedBy, updatedAt, catId, pageSize, pageNo });
  };

  const onSearchClickedDebounced = _.debounce(onSearchClicked, 500);

  const updateStatusOfPostInListWithoutRemovingIt = (id, newStatus, version) => {
    const scrappedPromosCopy = scrappedPromos.slice();
    for (const scrappedPromo of scrappedPromosCopy) {
      if (scrappedPromo.id === id) {
        scrappedPromo.status = newStatus;
        scrappedPromo.version = version;
        break;
      }
    }
    setScrappedPromos(scrappedPromosCopy);
  };

  const removePostFromList = (id) => {
    const p = _.filter(scrappedPromos, (o) => o.id !== id);
    setScrappedPromos(p);

    if (p.length === 0) {
      fetchScrappedPostData({ brand, type, status, lastUpdatedBy, updatedAt, catId, pageSize, pageNo });
    }
  };

  const onRejectClicked = (id, version) => {
    // Change scrapped promo's status
    props.updateScrappedPromo(id, { status: Status.Rejected, version })
      .then((res) => {
        // If selected filter is Pending, then we remove the scrapped promo from the list
        // so user can continue to process
        if (status === Status.Pending) {
          removePostFromList(id);
        } else {
          // Else just update the list
          updateStatusOfPostInListWithoutRemovingIt(id, Status.Rejected, res.version);
        }
      })
      .catch((err) => toast.error(err));
  };

  const onExpiredClicked = (id, version) => {
    // Change scrapped promo's status
    props.updateScrappedPromo(id, { status: Status.Expired, version })
      .then((res) => {
        // If selected filter is Pending, then we remove the scrapped promo from the list
        // so user can continue to process
        if (status === Status.Pending) {
          removePostFromList(id);
        } else {
          // Else just update the list
          updateStatusOfPostInListWithoutRemovingIt(id, Status.Expired, res.version);
        }
      })
      .catch((err) => toast.error(err));
  };

  const onRevertClicked = (id, version) => {
    // Change scrapped promo's status
    props.updateScrappedPromo(id, { status: Status.Pending, version })
      .then((res) => {
        // Keep the post shown in the listing so that user can re-process it again
        updateStatusOfPostInListWithoutRemovingIt(id, Status.Pending, res.version);
        toast.success('Post reverted');
      })
      .catch((err) => toast.error(err));
  };

  const convertToPost = async (scrappedPromo, postType, promoType) => {
    setShowAddPostModal(false);
    props.convertScrappedPromoToPost(scrappedPromo.id, postType, promoType, scrappedPromo.version)
      .then(async (post) => {
        toast.success('Post created');
        const p = _.filter(scrappedPromos, (o) => o.id !== scrappedPromo.id);
        setScrappedPromos(p);

        window.open(`/admin/scrappedPromo/${scrappedPromo.id}/page/${scrappedPromo.pageId}/post/${post.id}`, '_blank');
        if (p.length === 0) {
          fetchScrappedPostData({ brand, type, status, lastUpdatedBy, updatedAt, catId, pageSize, pageNo });
        }
      })
      .catch((err) => toast.error(err));
  };

  return (
    <>
      <div className="row" style={{ justifyContent: 'center' }}>
        <div className="col-md-12">
          <div className="content-header">
            <Grid item container direction="row" md={12} xs={12} style={{ minHeight: 60 }}>
              <Grid item xs={12} md={12}>
                <Typography variant="h1">Scrapped Posts</Typography>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="row" style={{ justifyContent: 'center' }}>
        <div className="col-md-12">
          <div className="content-header">
            <Grid item container direction="column" md={12} xs={12}>
              <Grid item container direction="row" md={12} xs={12} style={{ minHeight: 60 }}>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="inputPageName"
                    label="Search by Brand name"
                    style={{ position: 'relative', width: '100%', paddingBottom: 10, marginTop: 10 }}
                    onChange={(e) => { onSearchClickedDebounced(e.target.value); }}
                  />
                </Grid>

                &nbsp;

                <Grid item xs={12} md={3} style={{ paddingRight: 10 }}>
                  <TextField
                    id="inputPageType"
                    label="Page Type"
                    style={{ position: 'relative', width: '100%', paddingBottom: 10, marginTop: 10 }}
                    onChange={(e) => { handleChangePageTypeFilter(e.target.value); }}
                    select
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value={Constants.PageType.Mall}>{Constants.PageType.Mall}</MenuItem>
                    <MenuItem value={Constants.PageType.CreditCard}>{Constants.PageType.CreditCard}</MenuItem>
                    <MenuItem value={Constants.PageType.ECommerce}>{Constants.PageType.ECommerce}</MenuItem>
                  </TextField>
                </Grid>

                &nbsp;

                <Grid item xs={12} md={3}>
                  <TextField
                    id="inputStatus"
                    label="Status"
                    name="status"
                    value={status}
                    style={{ position: 'relative', width: '100%', paddingBottom: 10, marginTop: 10 }}
                    select
                    onChange={(e) => { handleOnChange(e); }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value={Constants.Status.Pending}>{ Constants.Status.Pending }</MenuItem>
                    <MenuItem value={Constants.Status.Rejected}>{ Constants.Status.Rejected }</MenuItem>
                    <MenuItem value={Constants.Status.Expired}>{Constants.Status.Expired}</MenuItem>
                    <MenuItem value={Constants.Status.Accepted}>{Constants.Status.Accepted}</MenuItem>
                  </TextField>
                </Grid>

                &nbsp;

                <Grid item xs={12} md={3}>
                  <TextField
                    id="inputLastUpdatedBy"
                    label="Last updated by"
                    name="lastUpdatedBy"
                    value={lastUpdatedBy}
                    style={{ position: 'relative', width: '100%', paddingBottom: 10, marginTop: 10 }}
                    select
                    onChange={(e) => { handleOnChange(e); }}
                  >
                    <MenuItem value="">All</MenuItem>
                    {
                      staffNames.map((name) => (
                        <MenuItem key={name} value={name}>{name.charAt(0).toUpperCase() + name.slice(1)}</MenuItem>
                      ))
                    }
                    {
                      !IsEmpty(staffNames) && staffNames.length > 1 && (
                        <MenuItem value="script">Script</MenuItem>
                      )
                    }
                  </TextField>
                </Grid>
              </Grid>

              <Grid item container direction="row" md={12} xs={12} style={{ minHeight: 60 }}>

                <Grid item>
                  <p style={{ margin: '10px 0 5px', fontSize: 10, fontWeight: 100, fontFamily: 'Roboto, Helvetica, Arial, sans-serif', color: '#888888' }}>Set a date range</p>
                  <DateRangePicker callback={(d) => setDatesFilter(d)} />
                </Grid>

                <Grid item xs={12} md={3} className="ml-3">
                  <FormControl style={{ width: '80%' }}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={filterGroupLabel ? filterGroupLabelOptions : categorySelection}
                      value={selectedCategory}
                      groupBy={(option) => (filterGroupLabel ? false : option.group)}
                      getOptionLabel={(option) => (filterGroupLabel ? option : option.name)}
                      style={{ width: '100%', marginTop: 10 }}
                      onChange={(e, values) => handleChangeCategory(values)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          value={selectedCategory}
                          label={filterGroupLabel ? 'Filter by Grouped Category' : 'Filter by Category'}
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl style={{ width: '20%' }}>
                    <Button
                      color={!filterGroupLabel ? 'default' : 'secondary'}
                      onClick={() => setFilterGroupLabel(!filterGroupLabel)}
                      variant={!filterGroupLabel ? 'outlined' : 'contained'}
                      style={{ fontSize: 10, marginTop: 10 }}
                    >
                      Grouped Category
                    </Button>
                  </FormControl>
                </Grid>

              &nbsp;

                <Grid item xs={12} md={window.innerWidth <= 1140 ? 2 : 3}>
                  <TextField
                    id="orderBy"
                    label="Order Listing By"
                    name="orderBy"
                    value={orderBy}
                    style={{ position: 'relative', width: '100%', paddingBottom: 10, marginTop: 10 }}
                    select
                    onChange={(e) => { handleOnChange(e); }}
                  >
                    <MenuItem value="score">Score</MenuItem>
                    <MenuItem value="created_at">Scrapped Date</MenuItem>
                  </TextField>
                </Grid>

              &nbsp;

                <Grid item xs={12} md={window.innerWidth <= 1430 ? 2 : 3}>
                  <TextField
                    id="orderDir"
                    label="Order By"
                    name="orderDir"
                    value={orderDir}
                    style={{ position: 'relative', width: '100%', paddingBottom: 10, marginTop: 10 }}
                    select
                    onChange={(e) => { handleOnChange(e); }}
                  >
                    <MenuItem value="ASC">ASC</MenuItem>
                    <MenuItem value="DESC">DESC</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

          </div>
        </div>
        <div className="col-md-12">
          {loading && <OverLoading />}
          { IsEmpty(scrappedPromos) && (
            <div className="alert alert-primary text-center mt-1 p-4" role="alert">
              <b>No Post(s) found.</b>
              &nbsp;Try new search or filter by Category.
            </div>
          ) }
          <List>
            { scrappedPromos.map((d) => (
              <ListItem key={_.uniqueId('scrappedPromoList_')}>
                <ScrappedPromo
                  key={_.uniqueId('scrappedPromo_')}
                  pageId={d.pageId}
                  content={d.content}
                  score={d.score}
                  link={d.url}
                  location={d.outlets}
                  lastUpdatedBy={d.lastUpdatedBy}
                  createdAt={d.createdAt}
                  updatedAt={d.updatedAt}
                  createdPostId={d.createdPostId}
                  brand={d.brand}
                  photos={d.photos}
                  videos={d.videos}
                  status={d.status}
                  onExpiredClicked={() => onExpiredClicked(d.id, d.version)}
                  onRejectClicked={() => onRejectClicked(d.id, d.version)}
                  onAcceptClicked={() => {
                    setScrappedPromoToConvert(d);
                    setShowAddPostModal(true);
                  }}
                  onRevertClicked={() => onRevertClicked(d.id, d.version)}
                  onVideoClicked={(url) => {
                    setVideoUrl(url);
                    setShowVideo(true);
                  }}
                />
              </ListItem>
            )) }
          </List>

          <div style={{
            position:   'fixed',
            bottom:     0,
            width:      '100%',
            background: '#fff',
            padding:    '30px 10px',
            zIndex:     9,
          }}
          >
            <>
              {totalCount > 0 && (
                <Pagination
                  color="secondary"
                  size="large"
                  count={totalCount}
                  page={pageNo}
                  onChange={handleChange}
                  className="float-left"
                />
              )}
              <p style={{
                display:  'inline-block',
                margin:   '10px 0 0 30px',
                fontSize: 17,
              }}
              >
                Total count:
                {' '}
                {allPostCount}
              </p>
            </>
          </div>

        </div>
        {
          showAddPostModal
            ? (
              <PostTypeModal
                displayText={scrappedPromoToConvert.content}
                onClose={() => setShowAddPostModal(false)}
                onComplete={(d) => convertToPost(scrappedPromoToConvert, d.postType, d.promoType)}
              />
            )
            : ''
        }
        <Dialog
          id="videoDialog"
          fullWidth
          maxWidth="sm"
          open={showVideo}
          onClose={() => setShowVideo(false)}
        >
          <ReactPlayer url={videoUrl} playing loop controls />
        </Dialog>
      </div>
    </>
  );
};

ScrappedPostList.propTypes = {
  convertScrappedPromoToPost: PropTypes.func.isRequired,
  getScrappedPromos:          PropTypes.func.isRequired,
  updateScrappedPromo:        PropTypes.func.isRequired,
  getCategories:              PropTypes.func.isRequired,
};

const mapActionsToProps = {
  convertScrappedPromoToPost, getScrappedPromos, updateScrappedPromo, getCategories,
};
export default connect(null, mapActionsToProps)(ScrappedPostList);
